var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _c(
        "div",
        { staticClass: "text-center rounded-circle bottom-margin mt-3" },
        [
          _c("img", {
            staticClass: "rounded-circle",
            attrs: { src: _vm.profile.gravatar_92 }
          })
        ]
      ),
      _c(
        "div",
        { staticClass: "mb-3 text-center mt-2" },
        [
          _vm.profile.country_id
            ? _c("omegaup-countryflag", {
                attrs: { country: _vm.profile.country_id }
              })
            : _vm._e(),
          _c("omegaup-user-username", {
            attrs: {
              classname: _vm.profile.classname,
              username: _vm.profile.username
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "mb-3 text-center" }, [
        _vm.profile.rankinfo.rank > 0
          ? _c("h4", { staticClass: "m-0" }, [
              _vm._v(" " + _vm._s("#" + _vm.profile.rankinfo.rank) + " ")
            ])
          : _c("small", [_c("strong", [_vm._v(" " + _vm._s(_vm.rank) + " ")])]),
        _c("p", [_c("small", [_vm._v(" " + _vm._s(_vm.T.profileRank) + " ")])]),
        _vm.profile.rankinfo.author_ranking > 0
          ? _c("h4", { staticClass: "m-0" }, [
              _vm._v(
                " " + _vm._s("#" + _vm.profile.rankinfo.author_ranking) + " "
              )
            ])
          : _c("small", [
              _c("strong", [
                _vm._v(" " + _vm._s(_vm.T.authorRankUnranked) + " ")
              ])
            ]),
        _c("p", [
          _c("small", [_vm._v(" " + _vm._s(_vm.T.profileAuthorRank) + " ")])
        ])
      ]),
      _vm.profile.is_own_profile || !_vm.profile.is_private
        ? _c(
            "div",
            {
              staticClass: "mb-3 text-center",
              attrs: { "data-solved-problems": "" }
            },
            [
              _c("h4", { staticClass: "m-0" }, [
                _vm._v(
                  " " + _vm._s(Object.keys(_vm.solvedProblems).length) + " "
                )
              ]),
              _c("p", [
                _c("small", [_vm._v(_vm._s(_vm.T.profileSolvedProblems))])
              ])
            ]
          )
        : _vm._e(),
      _vm.profile.preferred_language &&
      (_vm.profile.is_own_profile || !_vm.profile.is_private)
        ? _c(
            "div",
            {
              staticClass: "mb-3 text-center",
              attrs: { "data-preferred-programming-languages": "" }
            },
            [
              _c("h5", { staticClass: "m-0" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.profile.programming_languages[
                        _vm.profile.preferred_language
                      ].split(" ")[0]
                    ) +
                    " "
                )
              ]),
              _c("p", [
                _c("small", [
                  _vm._v(_vm._s(_vm.T.userEditPreferredProgrammingLanguage))
                ])
              ])
            ]
          )
        : _vm._e()
    ]),
    _vm.profile.is_own_profile
      ? _c(
          "div",
          { staticClass: "card-body text-center" },
          _vm._l(
            _vm.currentUrlMapping.filter(function(url) {
              return url.visible
            }),
            function(url) {
              return _c(
                "a",
                {
                  key: url.key,
                  staticClass: "btn btn-primary btn-sm my-1 w-100",
                  class: { disabled: url.key === _vm.selectedTab },
                  attrs: { href: "/profile/#" + url.key },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:selectedTab", url.key)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(url.title) + " ")]
              )
            }
          ),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }